<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row">
          <h2 class="mr-auto">
            {{ (isEditMode() ? 'lookupList.edit.title' : 'lookupList.create.title') | translate }}
          </h2>
          <div class="form-actions">
            <app-button class="" variant="outlined" type="button" (click)="onCancel()" [disabled]="saving()"
              data-testid="cancel-button">
              <app-icon name="x" />
              Cancel
            </app-button>
            <app-button variant="filled" type="button" (click)="save()" [disabled]="saveDisabled()"
              data-testid="save-button">
              @if (saving()) {
              <app-spinner [diameter]="18" />
              } @else {
              <app-icon name="save" />
              }
              Save
            </app-button>
          </div>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      @if (loading()) {
      <div class="loading-container flex flex-column flex-align-center p-lg gap-md">
        <app-spinner />
        <p>{{ 'lookupList.loading.single' | translate }}</p>
      </div>
      } @else if (error()) {
      <div class="error-banner flex flex-align-center gap-md p-md">
        <app-icon name="alert-circle" />
        <p>{{ error() }}</p>
      </div>
      } @else {
      <div class="form-body">
        <formly-form [form]="form" [fields]="fields" [model]="model" data-columns="2" data-testid="lookup-list-form" />
      </div>
      }
    </app-card-content>
  </app-card>
</div>